import React from 'react'
import PropTypes from 'prop-types'
import { RadioButton } from 'loyal-react'
import { CatalogCurrencyLabel } from 'Shared/CurrencyLabel'

const PointsOnly = ({ balance, selectPointsOnly, catalog, paymentSelected }) => {
  return (
    <div className='payment-item item h-auto col-12 border-color-ui-3 py-0'>
      <div className='row align-items-center h-100'>
        <RadioButton
          id='PointsOnly'
          name='PaymentMethod'
          label=''
          value='PointsOnly'
          ariaLabelledby='myPointsTxt'
          className='col-auto pl-0'
          role='radio'
          defaultChecked={paymentSelected === 'POINTS_ONLY'}
          onClick={selectPointsOnly}
        />
        <div className='col'>
          <p className='txt-body-sm' id='myPointsTxt' aria-hidden='false'>
            {`Utilizar apenas os meus ${catalog &&
            catalog.currencyConfiguration &&
            catalog.currencyConfiguration.pointsName}`}
          </p>
        </div>
        <div className='col txt-right'>
          <p className='txt-body-sm'>
            <small className='text-has'>{`Você possui: `}</small>
            <CatalogCurrencyLabel
              className='d-md-inline-block d-block txt-body-sm text-brand-bold'
              value={balance.pointsValue}
            />
          </p>
        </div>
      </div>
    </div>
  )
}

PointsOnly.propTypes = {
  balance: PropTypes.object.isRequired,
  selectPointsOnly: PropTypes.func.isRequired,
  catalog: PropTypes.object.isRequired,
  paymentSelected: PropTypes.string
}

export default PointsOnly



// WEBPACK FOOTER //
// ./src/features/Checkout/Payment/Body/PointsOnly/PointsOnly.js